import React from "react"
import { Cell } from "react-table"
import { CustomStyleColumn } from "../../components/Types/GeneralTypes";


const a:React.CSSProperties = {
    textAlign:"center"
}

function getGeneralCell<T extends Object>(cell: Cell<T>, stylesObjectGeneral: React.CSSProperties, renderObject?: any) {
    return (
        <td
            className={"tableHistorialcolumns"}
            {...cell.getCellProps()}
            style={{ ...stylesObjectGeneral }}
        >
            {
                renderObject !== undefined &&
                renderObject
            }
            {
                renderObject === undefined &&
                (
                    <div>
                        {cell.render('Cell')}
                    </div>
                )

            }

        </td>
    )
}


export function getTdTableStyles<T extends Object>(cell: Cell<T>, stylesObjectGeneral: React.CSSProperties, indice?: number, stylesProperties?: Array<CustomStyleColumn>, renderObject?: any) {

    // if(indice !== undefined) {
    //     cell.row.values = {...cell.row.values, "#":indice+1}
    // }


    if (stylesProperties) {
        
        var styleforHeader: Array<CustomStyleColumn> | undefined = stylesProperties.filter((sp) => sp.HeaderName === cell.column.Header);
        if (styleforHeader.length > 0) {
            var estilosDelRegistro: React.CSSProperties = {}
            styleforHeader.forEach(element => {
                const { StyleHeader, condition } = element;
                if (condition !== undefined && condition) {
                    estilosDelRegistro = { ...estilosDelRegistro, ...StyleHeader };

                }
                else if (condition === undefined) {
                    estilosDelRegistro = { ...estilosDelRegistro, ...StyleHeader };
                }
            });

            const estilosIncorporar:React.CSSProperties = { ...stylesObjectGeneral, ...estilosDelRegistro }

            return getGeneralCell(cell,estilosIncorporar,renderObject)            
        }
        else {
            return getGeneralCell(cell, stylesObjectGeneral,renderObject);
        }
    }
    else {
        return getGeneralCell(cell, stylesObjectGeneral,renderObject);
    }


}
